import { Observable } from "rxjs";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { EstatusProyecto } from "src/app/shared/model/proceso/estadoProyecto";

export class GrupoYears{
 id?: number;
 nombre:string;
 idPadre:number
 fecha_alta:string;
 fecha_vigencia:String;
 year_creacion:number;
 isCollapsed:boolean=true;
 listaOportunidad: Proyecto[];
 estado:EstatusProyecto ;
 idGrupo:number;
 username: string;
 name: string;
 idUser:number;
 tipoGrupo: string;
}